import React, { Component } from 'react';
import { Rnd } from 'react-rnd';
import { LayoutContext } from '../../../modules/ContextModules/LayoutContext';
import './LayerAttrsRnd.css'

export class LayerAttrsRnd extends Component {
    static contextType = LayoutContext;

    render() {
        const { LayerAttrsRndContext } = this.context;
        const style = {
            borderRadius: "5px",
            transition: "right 0.5s",
            border: "1px solid black",
            display: LayerAttrsRndContext.isShowLayerAttrsRnd ? "" : "none",
        };

        return (
            <Rnd
                style={style}
                position={{ x: LayerAttrsRndContext.layerAttrsRndPosition.x, y: LayerAttrsRndContext.layerAttrsRndPosition.y }}
                onDragStop={(e, d) => {
                    let layerAttrsRndPosition = { x: d.x, y: d.y };
                    LayerAttrsRndContext.update({ layerAttrsRndPosition: layerAttrsRndPosition });
                }}
                maxWidth='338px'
                maxHeight='397px'
                enableResizing={{
                    top: false,
                    right: false,
                    bottom: false,
                    left: false,
                    topRight: false,
                    bottomRight: false,
                    bottomLeft: false,
                    topLeft: false
                }}
                onResize={(e, direction, ref, delta, position) => {
                }}
            >
                <div className='layerAttrsRnd__title'>
                    {LayerAttrsRndContext.layerAttrsRndTitle}
                </div>
                <div className='layerAttrsRnd__context'>
                    <div className='layerAttrsRnd__table'>
                        <table>
                            <thead>

                            </thead>
                            <tbody>
                                {
                                    Object.keys(LayerAttrsRndContext.layerAttrsRnd).map((key, i) => {
                                        if (key === "") {
                                            return null;
                                        }
                                        return (
                                            <tr key={key} className='layerAttrsRnd__table__tr'>
                                                <th className='layerAttrsRnd__table__th1'>{key}</th>
                                                <th className='layerAttrsRnd__table__th2'>{LayerAttrsRndContext.layerAttrsRnd[key]}</th>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </Rnd>
        );
    }
}